import PropTypes from 'prop-types';
import React from 'react';

import {
  addMinutesToClock,
  formatClock12,
  formatDurationLabel,
  getAppointmentTypeColor,
} from '../../helpers';
import styles from './BookingRail.module.scss';

const BookingRail = ({ time, durationMinutes, appointmentTypeId }) => {
  const endTime = addMinutesToClock(time, durationMinutes);
  const colors = getAppointmentTypeColor({ appointmentTypeId });

  return (
    <div className={styles.rail} aria-label={`${formatClock12(time)} to ${formatClock12(endTime)}`}>
      <span className={styles.start}>{formatClock12(time)}</span>
      <span
        aria-hidden="true"
        className={styles.block}
        style={{
          height: Math.max(durationMinutes, 26),
          borderLeftColor: colors.border,
          background: colors.bg,
          color: colors.text,
        }}
      >
        {formatDurationLabel(durationMinutes)}
      </span>
      <span className={styles.end}>{formatClock12(endTime)}</span>
    </div>
  );
};

BookingRail.propTypes = {
  time: PropTypes.string.isRequired,
  durationMinutes: PropTypes.number.isRequired,
  appointmentTypeId: PropTypes.string,
};

export default BookingRail;
